<template>
  <section id="partners" class="no-pad" v-if="partners.children.length > 0">
    <h1 class="no-pad" v-html="partners.title"></h1>
    <partner :post="subpage" v-for="subpage in partners.children" :key="subpage.id" />
  </section>
</template>

<script>
import Partner from '../components/Partner.vue'

export default {
  name: 'partners',
  components: {
    Partner
  },
  computed: {
    partners () {
      return this.$store.getters.getPageByUID('partners')
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
@import '../assets/styles/base';
</style>
